(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name bmfexport.factory:Bmfexport
   *
   * @description
   *
   */
  angular
    .module('vcfinance.bmfexport')
    .factory('Bmfexport', Bmfexport);

  Bmfexport.$inject = ['restmod'];

  function Bmfexport(restmod) {
    return restmod.model('/routes/bmfexport');
  }
}());
